<div class="row">
    <div class="col-12">
        <div class="chart-container">
            <dx-chart #chart [dataSource]="dashboardData.data.values" (onPointClick)="pointClick($event)" (onLegendClick)="legendClick($event)">
    
                <dxi-series *ngFor="let source of dashboardData.data.sources" [valueField]="source.value" [name]="source.name | translate" [visible]="source.visible"></dxi-series>
                <dxo-common-series-settings #seriesSettings argumentField="hour" type="line">
                </dxo-common-series-settings>
            
                <dxo-argument-axis [valueMarginsEnabled]="true" discreteAxisDivisionMode="crossLabels">
                    <dxo-grid [visible]="true"></dxo-grid>
                </dxo-argument-axis>
            
                <dxo-title [text]="dashboardData.translated"></dxo-title>
                <dxo-legend verticalAlignment="bottom" horizontalAlignment="center" itemTextPosition="bottom">
                </dxo-legend>
                <dxo-export [enabled]="true"></dxo-export>
                <dxo-tooltip [enabled]="true"></dxo-tooltip>
                <!-- <dxo-zoom-and-pan argumentAxis="both"></dxo-zoom-and-pan>
                <dxo-scroll-bar [visible]="true" [opacity]="0.5" [width]="6"></dxo-scroll-bar> -->
            </dx-chart>
        </div>
    </div>
</div>